// extracted by mini-css-extract-plugin
export var actions = "_3x-0";
export var actionsContainer = "_3x-7";
export var border = "_3x-1";
export var childFullHeight = "_3x-f";
export var collapse = "_3x-2";
export var content = "_3x-a";
export var contentChild = "_3x-e";
export var fullscreen = "_3x-c";
export var hasLeftRadius = "_3x-k";
export var headerContainer = "_3x-3";
export var headerRow = "_3x-5";
export var hidePadding = "_3x-b";
export var navCollapsedGap = "_3x-l";
export var noScrollX = "_3x-m";
export var noScrollY = "_3x-n";
export var noTopPadding = "_3x-i";
export var optOutTopPadding = "_3x-d";
export var pageMain = "_3x-j";
export var pageOuter = "_3x-g";
export var pagePadding = "_3x-8";
export var pageScroll = "_3x-9";
export var profile = "_3x-o";
export var profileContainer = "_3x-p";
export var profileImage = "_3x-q";
export var profileMain = "_3x-r";
export var profileSubtitle = "_3x-t";
export var profileTitle = "_3x-s";
export var showLeftPadding = "_3x-h";
export var tabsPortalSlot = "_3x-6";
export var tabsWrapper = "_3x-4";
export var title = "_3x-u";